module.exports = __webpack_public_path__ + "img/zzchCode.bc6428f6.jpg";